import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FileText, ArrowLeft } from 'lucide-react';

const TermsOfUse = () => {
  return (
    <div className="min-h-screen bg-[#0A0F1C]">
      <Header />
      
      <div className="pt-40 pb-24 px-6">
        <div className="max-w-4xl mx-auto">
          <Link to="/" className="inline-flex items-center gap-2 text-[#2563EB] hover:text-[#3B82F6] mb-8 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>

          <div className="flex items-center gap-4 mb-8">
            <div className="w-14 h-14 bg-gradient-to-br from-[#2563EB] to-[#3B82F6] rounded-xl flex items-center justify-center">
              <FileText className="w-7 h-7 text-white" />
            </div>
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-[#F8FAFC]">Terms of Use</h1>
              <p className="text-[#94A3B8]">Last updated: January 2025</p>
            </div>
          </div>

          <div className="prose prose-invert prose-lg max-w-none">
            <div className="text-[#94A3B8] leading-relaxed space-y-6">
              <p className="text-lg">
                Please read these Terms of Use carefully before using the PriceStrike platform. By accessing or using our services, you agree to be bound by these terms.
              </p>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8 mt-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">Acceptance of Terms</h2>
                <p>
                  By creating an account or using PriceStrike, you acknowledge that you have read, understood, and agree to be bound by these Terms of Use and our Privacy Policy.
                </p>
              </div>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">Use of Services</h2>
                <p>You agree to use PriceStrike only for lawful purposes and in accordance with these Terms. You agree not to:</p>
                <ul className="list-disc pl-6 space-y-2 mt-4">
                  <li>Use the service in any way that violates applicable laws</li>
                  <li>Attempt to gain unauthorized access to any portion of the service</li>
                  <li>Interfere with or disrupt the service or servers</li>
                  <li>Use automated systems to access the service without permission</li>
                  <li>Impersonate any person or entity</li>
                </ul>
              </div>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">Intellectual Property</h2>
                <p>
                  The service and its original content, features, and functionality are owned by PriceStrike and are protected by international copyright, trademark, and other intellectual property laws.
                </p>
              </div>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">Subscription and Payments</h2>
                <p>
                  Certain aspects of the service are provided on a subscription basis. You agree to pay all fees associated with your subscription plan. All fees are non refundable except as required by law.
                </p>
              </div>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">Disclaimer of Warranties</h2>
                <p>
                  The service is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee that the service will be uninterrupted, secure, or error free.
                </p>
              </div>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">Limitation of Liability</h2>
                <p>
                  In no event shall PriceStrike be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the service.
                </p>
              </div>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">Changes to Terms</h2>
                <p>
                  We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through the service.
                </p>
              </div>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">Contact Information</h2>
                <p>
                  For questions about these Terms of Use, contact us at:
                </p>
                <p className="mt-4">
                  Email: <a href="mailto:legal@axiosera.com" className="text-[#2563EB] hover:text-[#3B82F6]">legal@axiosera.com</a><br />
                  Address: Drielandendreef 42, 3845 CA, Harderwijk, The Netherlands
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default TermsOfUse;
